import React from 'react';
import { Check } from 'lucide-react';
import { founderData } from '../data/mock';

export const FounderSection = () => {
  const credentials = [
    "UAE Accounting & Tax Advisory",
    "Corporate Tax & VAT Compliance",
    "Free Zone & Mainland Business Advisory",
    "Audit Support & Financial Reporting"
  ];

  return (
    <section id="founder" className="py-24 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="container mx-auto px-6">
        {/* Professional Executive Profile Header */}
        <div className="text-center max-w-4xl mx-auto mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            {founderData.title}
          </h2>
          <p className="text-xl md:text-2xl text-secondary font-semibold mb-6">
            Accounting, Tax & Financial Advisory Expert | 15+ Years of Experience
          </p>
          
          {/* Trust & Authority Badges */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {credentials.map((credential, index) => (
              <div
                key={index}
                className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-secondary/20"
              >
                <Check className="text-secondary" size={18} />
                <span className="text-sm font-medium text-foreground">{credential}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Professional Content Section */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-2 border-secondary/10">
            {/* Founder Title */}
            <div className="text-center mb-8 pb-6 border-b-2 border-secondary/10">
              <h3 className="text-3xl font-bold text-primary">
                Founder
              </h3>
            </div>

            {/* Professional Bio - Improved Typography */}
            <div className="space-y-8 text-foreground">
              <p className="text-lg leading-relaxed text-gray-700">
                {founderData.bio}
              </p>
              
              <p className="text-lg leading-relaxed text-gray-700">
                {founderData.expertise}
              </p>
              
              <p className="text-lg leading-relaxed text-gray-700">
                {founderData.credentials}
              </p>
            </div>

            {/* Professional Footer */}
            <div className="mt-10 pt-8 border-t-2 border-secondary/10 text-center">
              <p className="text-secondary font-semibold text-lg">
                Leading Shine Core Advisory LLC with a compliance-first, accuracy-driven approach
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
